export default __webpack_public_path__ + "static/media/videocall.f585c05a.png";